module.exports = __webpack_public_path__ + "img/Group 57.b7a92e6f.png";